import apiClient from '../apiClient';
import { UPLOAD_COMMIT_ACCOMODATION_ITEM_URL } from '../apiUrl';

const uploadMasterAccomodationItemApi = data => {
  return apiClient.post(UPLOAD_COMMIT_ACCOMODATION_ITEM_URL, data);
};

export default uploadMasterAccomodationItemApi;
